var React = require('react');

function IconFilterSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M890.2 122.8l33.3-40.4c8.5-10.3 4.8-18.7-8.8-18.7H111c-13.3 0-16.6 9.2-8.9 18.6l32.9 40.3 280.5 344 7.9 9.7-8.1-22.8v491.4c0 13.7 7.6 17.2 17.5 7.2l44.1-44.1 115.4-115.4 10.6-10.6V471.5"}));
}

IconFilterSolid.displayName = "IconFilterSolid";

IconFilterSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconFilterSolid;

IconFilterSolid.default = IconFilterSolid;
